import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Tooltip, Typography } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";
/**
 * Displays a label with a title and optional tooltip.
 */
const Label = ({ title, tooltip }) => {
    return (
    // max-height here ensures the label aligns properly with inputs,
    // staying top-aligned for multi-line fields like textareas.
    _jsxs("div", { className: "te-flex te-flex-row te-gap-2 te-h-full te-max-h-[40px] te-items-center", children: [_jsx(Typography.Text, { ellipsis: true, children: title }), tooltip && (_jsx(Tooltip, { title: tooltip, children: _jsx(QuestionCircleOutlined, {}) })), _jsx(Typography.Text, { children: ":" })] }));
};
export default Label;
